// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-section footer-contact">
        <h3>Contact Us</h3>
        <address>
        <i className="fas fa-phone"></i>&nbsp; Call us : +233 30 293 7238 | +233 50 776 2500 <br />
        <i className="fas fa-envelope"></i>&nbsp; E-mail : <a href="mailto:info@asg.org.gh">info@asg.org.gh</a> <br />
          <a href='https://maps.app.goo.gl/4BY8ATncivTT5Qua7'> <i className="fas fa-map-marker-alt"></i> &nbsp;3rd Floor SSNIT AIA Building <br />
          Nkrumah Circle - Kaneshie Road, Accra</a>
        </address>
      </div>
      <div className="footer-section footer-connect">
        <h3>Let's Connect</h3>
        <div className="social-icons">
          <a href="https://web.facebook.com/profile.php?id=167224210148526&_rdc=1&_rdr&checkpoint_src=any" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://x.com/Actuarial_Ghana" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://www.instagram.com/actuarialghana/?hl=en" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCec_a76VfE1oiXN7zk5OM0Q" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube"></i>
          </a>
          <a href="https://www.linkedin.com/groups/8268676/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin"></i>
          </a>
        </div>
      </div>
      <div className="footer-section footer-links">
        <a href="/terms">Terms of Membership & Privacy Policy</a>
        <a href="/manual">ASG Manual</a>
        <a href="/disclaimer">Website Disclaimer and Copyright</a>
      </div>
    </footer>
  );
}

export default Footer;
